import { useEffect, useState } from "react";
import { BubbleChart } from "../campaignInsightsPage/campaignInsightsOverview/overviewCharts/BubbleChart";

export type TransformedDataType = {
  category: string;
  impressions: number;
};

type CircleChartProps = {
  transformedData: TransformedDataType[];
  dataColours?: boolean;
};

export const CircleChart = ({
  transformedData,
  dataColours,
}: CircleChartProps) => {

  const [bubbleChartData, setBubbleChartData] = useState<TransformedDataType[]>([]);
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    setBubbleChartData([...transformedData]);
    setLoading(false);
  }, [transformedData]);

  
  return (
    <>
      <BubbleChart
        categoryInsights={bubbleChartData}
        dataColours={dataColours}
        dataLoading={loading}
      />
    </>
  );
};
